module.exports = __webpack_public_path__ + "static/media/kaple-srdce.2508da77.jpg";